import { environment } from "src/environments/environment";

export const CONFIG = {
    placeholder: '',
    tabsize: 2,
    height: '200px',
    uploadImagePath: environment.uploadImageBaseUrl,
    toolbar: [
        ['misc', ['codeview', 'undo', 'redo']],
        ['font', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
        ['fontsize', ['fontname', 'fontsize', 'color']],
        ['para', ['style', 'ul', 'ol', 'paragraph', 'height']],
        ['insert', ['table', 'picture', 'link', 'hr']]
    ],
    fontNames: ['Helvetica', 'Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Roboto', 'Times']
};